import React, { Component } from 'react';
import styled from 'styled-components';

const StyledFormActionButtonsContainer = styled.div`
  right: 75px;
  position: absolute;
`;

export const FormActionButtonsContainer: React.FC<any> = props => {
  return <StyledFormActionButtonsContainer {...props}>{props.children}</StyledFormActionButtonsContainer>;
};

export default FormActionButtonsContainer;
